module.exports = __webpack_public_path__ + "img/发票下载.5d5ebc54.svg";